import * as React from "react"
import { cn } from '@/utils/index'

export const PaginationContent = React.forwardRef<HTMLUListElement, React.ComponentProps<"ul">>(
  ({ className, ...props }, ref) => (
    <ul ref={ref} className={cn("flex flex-row items-center gap-6 px-6", className)} {...props} />
  )
)
PaginationContent.displayName = "PaginationContent"
